import React from "react";
import "../css/PrintInvoiceSummary.css";
import { doctorSettingAtom } from "../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
import { getImageURL } from "../../_helper/utils/image";

export default function PrintInvoiceSummary({
  institutionName,
  gstNo,
  panNo,
  billNo,
  billDate,
  tableCols,
  tableRows,
  invoiceTotal,
  amtInWord,
}) {
  const [{ prescription_setup: settings, header_footer_setup }] =
    useAtom(doctorSettingAtom);

  console.log(
    "HEADER-FOOTER-SETUP",
    header_footer_setup[settings?.pageSize].signatureHeight
  );
  return (
    <div className="cu-setup-invoice-summary text-[12px]">
      <div className="print-header">
        <img
          src={getImageURL(header_footer_setup[settings?.pageSize]?.headerUrl)}
          alt="header"
          style={{
            width: "100%",
            height: "100%",
          }}
        />
      </div>
      <div className="cu-invoice-summary-title p-5">Billing Summary</div>

      {/* Left and right flex container */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        {/* Left side (To, GST, PAN) */}
        <div style={{ flex: 1 }}>
          <div className="cu-institution-name">
            <span style={{ fontWeight: 700 }}>To: </span>
            <span>{institutionName}</span>
          </div>
          {/* <div className="cu-institution-name">
            <span style={{ fontWeight: 700 }}>GST Tin No: </span>
            <span>{gstNo}</span>
          </div> */}
          {/* <div className="cu-institution-name">
            <span style={{ fontWeight: 700 }}>PAN No: </span>
            <span>{panNo}</span>
          </div> */}
        </div>

        {/* Right side (Bill No, Date) */}
        <div style={{ textAlign: "right" }}>
          <div>
            <span style={{ fontWeight: 700 }}>Bill No: </span>
            <span>{billNo}</span>
          </div>
          <div>
            <span style={{ fontWeight: 700 }}>Date: </span>
            <span>{billDate}</span>
          </div>
        </div>
      </div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "12px",
          borderTop: "1px solid black",
          borderLeft: "1px solid black",
        }}
      >
        <thead className="cu-setup-invoice-summary-table-header">
          <tr>
            {tableCols.map((col, index) => (
              <th
                key={index}
                style={{
                  fontWeight: 700,
                  padding: "10px 10px 10px 10px",
                  borderRight: "1px solid black",
                  textAlign: "center",
                }}
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableRows?.map((row, rowIndex) => (
            <tr key={rowIndex}>
              <td style={{ width: "40px", textAlign: "center" }}>
                {rowIndex + 1}
              </td>
              <td style={{ width: "80px", textAlign: "center" }}>
                {row.slip_no || ""}
              </td>
              <td style={{ width: "90px", textAlign: "center" }}>
                {row.invoice_date || ""}
              </td>
              <td style={{ width: "120px", textAlign: "center" }}>
                {row.patient_name || ""}
              </td>
              <td style={{ width: "160px", textAlign: "center" }}>
                {row.diagnosis || ""}
              </td>
              <td style={{ width: "160px", textAlign: "center" }}>
                {row.treatment || ""}
              </td>
              <td style={{ textAlign: "center" }}>
                {row.consultancy_charges !== undefined
                  ? row.consultancy_charges
                  : "NA"}
              </td>
              <td style={{ textAlign: "center" }}>
                {row.medicine_charges !== undefined
                  ? row.medicine_charges
                  : "NA"}
              </td>
              <td style={{ textAlign: "center" }}>
                {row.invoice_total !== undefined ? row.invoice_total : "NA"}
              </td>
            </tr>
          ))}

          {/* Total row */}
          <tr>
            <td
              colSpan={6}
              style={{
                fontWeight: 700,
                textAlign: "right",
                paddingRight: "10px",
              }}
            >
              Total
            </td>
            <td colSpan={3} style={{ fontWeight: 700, textAlign: "center" }}>
              {invoiceTotal}
            </td>
          </tr>

          {/* In Words and Prepared By row */}
          <tr>
            <td colSpan={4} style={{ fontWeight: 700 }}>
              In Words: Rupees {amtInWord} Only.
            </td>
            <td colSpan={5} style={{ fontWeight: 700, textAlign: "center" }}>
              For Chaitanya Multispeciality Hospital
            </td>
          </tr>
          <tr>
            <td
              colSpan={9}
              style={{
                fontWeight: 700,
                height: "120px",
                textAlign: "left",
                padding: "10px",
                position: "relative",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  marginTop: "10px",
                }}
              >
                {/* Left-aligned "Prepared By" text */}
                <div style={{ flex: 1, textAlign: "left" }}>
                  <strong>Prepared By:</strong>
                </div>

                {/* Right-aligned signature */}
                <div style={{ textAlign: "center" }}>
                  <img
                    src={getImageURL(
                      header_footer_setup[settings?.pageSize]?.signatureImg
                    )}
                    alt="Prepared By Signature"
                    style={{
                      height: `${header_footer_setup[settings?.pageSize].signatureHeight}cm`, // Adjust height for better resizing
                      width: `${
                        header_footer_setup[settings?.pageSize].signatureWidth
                      }cm`, // Maintain aspect ratio
                      objectFit: "contain",
                      transformOrigin: "center", // Zoom from the center
                      zoom: "50%",
                    }}
                  />
                  <div
                    style={{
                      marginTop: "5px",
                      fontSize: "12px",
                      fontWeight: 500,
                    }}
                  >
                    <strong>Authorized Signatory</strong>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div
        style={{
          width: "100%",
          fontWeight: 700,
          textAlign: "center",
          padding: "10px 0",
        }}
      >
        Note: If you have any questions concerning this Bill, contact our
        HR/Account Dept.
      </div>
    </div>
  );
}
